import React from 'react';

import { Box, alpha, useTheme } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';

const TOOLBAR_BUTTON_SX = { borderRadius: 2, textTransform: 'none' } as const;

export default function PayForPointsToolbar() {
  const theme = useTheme();
  return (
    <GridToolbarContainer
      sx={{
        padding: 2,
        gap: 2,
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        bgcolor: alpha(theme.palette.background.paper, 0.6),
        backdropFilter: 'blur(10px)',
      }}
    >
      <GridToolbarColumnsButton slotProps={{ button: { sx: TOOLBAR_BUTTON_SX } }} />
      <GridToolbarFilterButton slotProps={{ button: { sx: TOOLBAR_BUTTON_SX } }} />
      <GridToolbarExport slotProps={{ button: { sx: TOOLBAR_BUTTON_SX } }} />
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarQuickFilter
        debounceMs={500}
        sx={{
          '& .MuiInputBase-root': {
            borderRadius: 2,
            bgcolor: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(10px)',
          },
        }}
      />
    </GridToolbarContainer>
  );
}
